
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/new-homes/northern-ireland",
      function () {
        return require("private-next-pages/new-homes/northern-ireland.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/new-homes/northern-ireland"])
      });
    }
  